document.addEventListener("click", function (event) {
  const swatch = event.target.closest("color-swatch-variant");
  if (!swatch) return;

  const newImageUrl = swatch.dataset.variantImage;
  if (!newImageUrl) return;

  const card = swatch.closest(".product-grid-item");
  if (!card) return;

  const img = card.querySelector(".product-grid-item__thumbnail img.motion-reduce");
  if (!img) return;

  img.removeAttribute("srcset");
  img.removeAttribute("sizes");
  img.src = newImageUrl;

  card.querySelectorAll("color-swatch-variant").forEach(function (el) {
    el.classList.remove("checked-color");
  });
  swatch.classList.add("checked-color");
});